<template>
  <v-row class="pt-5" v-if="doc">
    <v-col cols="6" offset="3">
      <v-row>
        <v-col cols="12">
          <v-simple-table
            dark
            class=""
            v-for="(tov, index) in results"
            :key="`table=${index}`"
          >
            <template v-slot:default>
              <tov-header></tov-header>
              <tbody>
                <tov-row from="Funny" to="Serious" v-model="tov.row1"></tov-row>
                <tov-row from="Formal" to="Casual" v-model="tov.row2"></tov-row>
                <tov-row
                  from="Respectful"
                  to="Irreverent"
                  v-model="tov.row3"
                ></tov-row>
                <tov-row
                  from="Enthusiastic"
                  to="Matter of fact"
                  v-model="tov.row4"
                ></tov-row>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import { TovRow, TovHeader } from "@/components/core";
export default {
  name: "ResultsFunctionalityUser",
  data() {
    return {
      doc: null,
      cols: 4,
    };
  },
  props: {
    uid: String,
  },
  components: {
    TovRow,
    TovHeader,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.getExercise(this.uid);
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    results() {
      if (typeof this.doc.tov != undefined) {
        const ordered = Object.keys(this.doc.tov)
          .sort()
          .reduce((obj, key) => {
            obj[key] = this.doc.tov[key];
            return obj;
          }, {});
        return ordered;
      } else {
        return [];
      }
    },
  },
  methods: {
    getExercise(id) {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.tovExCollection
        .where("uid", "==", id)
        .where("pid", "==", this.currentProjectModel.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0];
          }
        })
        .catch(function() {});
    },
  },
};
</script>
